import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class HoldForTurboUIAct extends SyncUIActDecorator {
    public execute(): void {
        listenUIDisabled(this);

        this.emitter.emit('UI.updateUIElementsState', 'HoldForTurboUIState');
        this.emitter.emit('UI.holdForTurboActivated');
        this.emitter.emit('UI.reelSpin.setLevel', ReelsSpeedLevel.turbo_2);
        this.emitter.emit('UI.command.spin');

        this.emitter.on('Game.command.canProceedAutoSpin', () => {
            this.onExecuted?.();
        });

        this.emitter.on('UI.spinButton.pressed', this.finishHoldForTurbo.bind(this));
        this.emitter.on('UI.spinButton.pointerout', this.finishHoldForTurbo.bind(this));

        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            slotStore.batchUpdate({
                feature_type: data
            });

            this.removeAllListeners();
            this.finishHoldForTurbo();
            this.onExecuted?.();
        });
    }

    protected finishHoldForTurbo(): void {
        this.emitter.emit('UI.reelSpin.setLevel', ReelsSpeedLevel.normal);

        slotStore.isHoldForTurboMode.value = false;
        this.emitter.emit('UI.holdForTurboDeactivated');
    }

    getName(): string {
        return 'IdleUIAct';
    }
}